<script setup lang="ts">
import CorporateGovernanceSupervisorHero from '@/domains/investor/corporate-governance/supervisor-board/components/Hero/Hero.vue'
import ManagementTeam from '~/domains/investor/corporate-governance/components/ManagementTeam/ManagementTeam.vue'
import { useFetchBoard } from '@/domains/investor/composables/useFetchBoard'

definePageMeta({
  layout: 'investor',
})

const { t, locale } = useI18n()

useHead(() => ({
  title: t('pageTitles.investorSupervisoryBoard.title'),
  meta: [
    {
      name: 'description',
      content: t('pageTitles.investorSupervisoryBoard.meta'),
    },
  ],
  link: [
    {
      rel: 'canonical',
      href: t(`pageTitles.investorSupervisoryBoard.canonical.${locale.value}`),
    },
    {
      rel: 'alternate',
      hreflang: 'pl',
      href: t('pageTitles.investorSupervisoryBoard.canonical.pl'),
    },
    {
      rel: 'alternate',
      hreflang: 'en',
      href: t('pageTitles.investorSupervisoryBoard.canonical.en'),
    },
    {
      rel: 'alternate',
      hreflang: 'x-default',
      href: t('pageTitles.investorSupervisoryBoard.canonical.pl'),
    },
  ],
}))

const { fetchBoard } = await useFetchBoard()
const superVisorResponse = await fetchBoard('corporate_governance_supervisor_board')
const superVisorAuditResponse = await fetchBoard('corporate_governance_supervisor_audit_board')
const superVisorNominationResponse = await fetchBoard('corporate_governance_supervisor_nomination_board')
const supervisorTeam = superVisorResponse.data.value
const superVisorAuditTeam = superVisorAuditResponse.data.value
const supervisorNominationTeam = superVisorNominationResponse.data.value

</script>

<template>
  <CorporateGovernanceSupervisorHero />

  <ManagementTeam
    :id="$t('investor.corporateGovernance.supervisorBoard.hero.firstButton.url').replace('#', '')"
    path-key-to-url="for-investors-corporate-governance-supervisory-board-member"
    v-bind="supervisorTeam"
  />

  <ManagementTeam
    class="managementTeam--grayBg"
    path-key-to-url="for-investors-corporate-governance-audit-board-member"
    v-bind="superVisorAuditTeam"
  />

  <ManagementTeam
    path-key-to-url="for-investors-corporate-governance-nomination-board-member"
    v-bind="supervisorNominationTeam"
  />
</template>

<style lang="scss">
  .managementTeam.managementTeam--grayBg {
    max-width: 100%;
    background-color: $gray-100;

    @include atM {
      .managementTeam__grid {
        max-width: 136rem;
        margin: auto;
      }
    }
  }

</style>
